module.exports = __webpack_public_path__ + "img/examineLeave.e30578d5.png";